/* Copyright 2023 (Unpublished) Verto Inc. */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private _token: string;
  private _email: string;

  constructor(private http: HttpClient) {
    this._token = this.token;
  }

  public login(username: string, password: string): Observable<boolean> {
    return this.http
      .post(environment.settings.backendUrl + '/auth/token', {
        username,
        password,
      })
      .pipe(
        tap((result: { token: string }) => {
          this.token = result.token;
          this.email = username;
        }),
        map((result: { token?: string; description?: string }) => {
          return !!result.token;
        })
      );
  }

  public set token(token: string) {
    this._token = token;
    if (!!token) {
      localStorage.setItem('t', token);
    } else {
      localStorage.removeItem('t');
      localStorage.removeItem('access_token');
      sessionStorage.removeItem('access_token');
    }
  }

  public get token(): string {
    // Try to get oauth access token first, fall back to custom automate login token
    return localStorage.getItem('access_token') || localStorage.getItem('t');
  }

  public set email(email: string) {
    this._email = email;
    if (!!email) {
      localStorage.setItem('e', email);
    } else {
      localStorage.removeItem('e');
    }
  }

  public get email(): string {
    return localStorage.getItem('e');
  }

  logout() {
    this.token = null;
    this.email = null;
  }
}
